import * as React from 'react';
import { Layout, Row } from 'antd';
import styled from 'styled-components';
import ScreenHelper from '../../Styled/ScreenHelper';
import logoSvg from '../../../assets/images/logo.png'

const { Header, Content, Footer } = Layout;

export const CenteredContent = styled(Content)`
  height: 100%;
  min-height: 100vh;
  ${ScreenHelper.down('md')`
      padding-top:1vh;
  `}
  ${ScreenHelper.up('md')`
      padding-top:15vh;
  `}
`;

export const MainLogo = styled.div`
  height: 10em;
  width: 21em;

  border: none;
  background: url(${logoSvg});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;

  ${ScreenHelper.down('sm')`
        height: 8em;
        width: 10em;
  `}
`;
